export default __webpack_public_path__ + "static/media/logo2023.0424b0c9.png";